module.exports = __webpack_public_path__ + "img/PauseShape.e684b41b.png";